import React from "react";

export default function ImageTextSection({
  image,              // main image (left side)
  imageAlt,
  title,
  description,
  buttonText,
  buttonLink,
  bgColor = "bg-[#C03CA0]",   // fallback background
  bgPattern,          // optional pattern image (e.g. cheese pattern)
  bgPatternAlt,
  reverse = false,    // optional to flip sides
}) {
  return (
    <section
  className={`relative w-full flex flex-col lg:flex-row ${
    reverse ? "lg:flex-row-reverse" : ""
  } rounded-2xl overflow-hidden shadow-sm bg-white`}
>
  <div className="flex flex-col lg:flex-row gap-5 lg:gap-8 w-full p-4 lg:p-6 rounded-2xl bg-white">
    {/* LEFT IMAGE */}
    <div className="w-full lg:w-1/2 overflow-hidden rounded-xl">
      <img
        src={image}
        alt={imageAlt}
        loading="lazy"
        decoding="async"
        className="w-full h-full object-cover block rounded-xl"
      />
    </div>

    {/* RIGHT CONTENT */}
    <div
      className={`relative w-full lg:w-1/2 flex flex-col justify-center text-white ${bgColor} rounded-xl`}
    >
      {bgPattern && (
        <img
          src={bgPattern}
          alt={bgPatternAlt}
          loading="lazy"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover pointer-events-none rounded-xl"
        />
      )}

      <div className="relative z-10 p-8 lg:p-16 space-y-4">
        <h2 className="text-2xl lg:text-4xl font-bold">{title}</h2>
        <p className="text-md lg:text-base leading-relaxed max-w-lg">
          {description}
        </p>

        {buttonText && (
          <a
            href={buttonLink}
            className="inline-flex items-center gap-2 bg-white text-[#C03CA0] font-medium px-5 py-2 rounded-md mt-4 hover:bg-gray-100 transition"
          >
            {buttonText}
          </a>
        )}
      </div>
    </div>
  </div>
</section>

  );
}
